export let SystemManage = {
    path: 'system-manage',
    name: 'system-manage',
    meta: {
        roleCode: '015',
    },
    component: () =>
        import(
            /* webpackChunkName: "system-manage-page" */ '@/views/back-stage/system-manage/system-manage-page.vue'
        ),
    children: [
        {
            path: 'orgrole',
            name: 'org-role',
            meta: {
                roleCode: '01501',
            },
            component: () =>
                import(
                    /* webpackChunkName: "org-role" */
                    '@/views/back-stage/org-role/org-role.vue'
                ),
        },
        {
            path: 'workingcalendar',
            name: 'working-calendar',
            meta: {
                roleCode: '01502',
            },
            component: () =>
                import(
                    /* webpackChunkName: "working-calendar" */
                    '@/views/back-stage/working-calendar/working-calendar.vue'
                ),
        },
        {
            path: 'messageset',
            name: 'messageset',
            meta: {
                roleCode: '01503',
            },
            component: () =>
                import(
                    /* webpackChunkName: "message-set" */
                    '@/views/back-stage/message-set/message-set.vue'
                ),
        },
        {
            path: 'licenseset',
            name: 'license-set',
            meta: {
                roleCode: '01504',
            },
            component: () =>
                import(
                    /* webpackChunkName: "license-set" */
                    '@/views/back-stage/system-manage/license-set.vue'
                ),
        },
        {
            path: 'system-param',
            name: 'system-param',
            component: () =>
                import(
                    /* webpackChunkName: "system-param" */
                    '@/views/back-stage/system-manage/system-param.vue'
                ),
        },
        {
            path: 'adminset',
            name: 'admin-set',
            component: () =>
                import(
                    /* webpackChunkName: "admin-set" */ '@/views/back-stage/system-manage/admin-set.vue'
                ),
        },
        {
            path: '*',
            redirect: 'orgrole',
        },
    ],
};
